// extracted by mini-css-extract-plugin
export default {"top":"_0506a02d741a62f77a29936730616617","noDots":"a91868646397e6c72d408c69c2e4efca"};